// extracted by mini-css-extract-plugin
export var change = "_48-1";
export var changeList = "_48-0";
export var changePath = "_48-2";
export var diffArrow = "_48-5";
export var diffRow = "_48-3";
export var diffValue = "_48-4";
export var error = "_48-8";
export var notice = "_48-9";
export var result = "_48-6";
export var success = "_48-7";